import { ChangeDetectorRef, Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "src/app/shared/translate.service";
import { IBreadCrumbData } from "./breadcrumbs.interface";
import { ProductosService } from "src/app/business/productos.service";

@Component({
  selector: "app-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
  styleUrls: ["./breadcrumbs.component.scss"],
})
export class BreadCrumbsComponent implements OnInit, OnChanges {

  @Input() dataBreadCrumb: IBreadCrumbData[];

  opened: boolean = true;
  infobreadcrumb: any[] = [];
  currentRoute: string;
  breadarray: any[] = []; //string
  breadlength: number;
  translation: any;

  allData1: any[] = [];
  allData2: any[] = [];
  allData3: any[] = [];

  constructor(
    private router: Router,
    private _ruta: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private translator: TranslateService,
    private productosService: ProductosService,
  ) {
  }

  ngOnInit() {
    // this.initializeTranslate();
    console.log({
      message: "ngOnInit called",
      dataBreadCrumb: this.dataBreadCrumb
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log({
      message: "ngOnChanges called",
      changes
    })
    if (changes.dataBreadCrumb && this.dataBreadCrumb) {
      this.buildBreadArray();
    }
  }

  buildBreadArray() {
    this.breadarray = this.dataBreadCrumb.map(bread => ({
      crumb: bread.text,
      urlcrumb: bread.url,
      resetData: bread.resetData || false,
    }));
    this.breadlength = this.breadarray.length;
  }

  clickCrumb(u, resetData: boolean = false) {
    // this.layoutservices.urlclicked.emit(u);
    if (resetData) {
      this.productosService.setDatosInitValue(undefined);
    }
    this.router.navigateByUrl(u);
  }
}
